module.exports = [
  {
    title: {
      zh: '旅遊高等學校',
      en: 'Tourism College',
    },
    description: {
      zh: '提供不同範疇的學士學位課程，包括以英文授課的六個日間學位課程和以中文授課的三個夜間學位課程，涵蓋會展、旅遊、商業管理等不同領域。為促使學生透過實踐經驗以鞏固其理論基礎，所有學生必須進行為期六個月的實習。在實習過程中，培養其專業態度以及學習適應現實社會的工作環境，學生亦可借助實習計劃去探索其未來職業發展路向。',
      en: 'Offering 6 daytime bachelor degree programmes taught in English and 3 evening bachelor degree programmes taught in Chinese, covering areas from hospitality to tourism and business management. With the goal of consolidating students’ knowledge with first-hand experience, a 6-month internship is compulsory for all students. During the internship, students can explore and develop a professional attitude and the adaptability needed for their future career. They can also explore their career path via the internship programme.',
    },
    image: '/images/home/school-01.jpg',
    link: {
      zh: 'zh/tourism-college',
      en: 'tourism-college',
    },
  },
  {
    title: {
      zh: '旅遊及酒店業學校',
      en: 'Tourism and Hotel School',
    },
    description: {
      zh: '開辦不同主題的日間及夜間課程，吸引不少為不同目的進修或裝備自己的人士報讀。此外，亦有在職人士透過這些課程評核取得國際認可的專業資格。同時，學校與業界及社區保持緊密的合作關係，配合不同機構的需求提供酒店；餐飲；文化遺產及旅遊；零售、會展及商業；創意藝術及資訊科技；健康、美容及美療；語言文化以及自我提升等多個範疇不同程度的培訓課程。',
      en: 'To promote lifelong learning, Tourism and Hotel School offers a range of daytime and evening courses for students who join the School with different needs. It also offers courses and related examinations for students to acquire international qualifications. Meanwhile, the School works closely with the community to offer a selection of courses of different levels in different areas, including Hospitality; Food and Beverage; Heritage and Tourism; Health, Spa and Beauty; Creative Studies and IT; Language and Culture; Retail, Events and Business; Personal Development, in response to the society’s demands.',
    },
    image: '/images/home/school-02.jpg',
    link: {
      zh: 'zh/tourism-and-hotel-school',
      en: 'tourism-and-hotel-school',
    },
  },
]
